import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Maintenance } from '@shared/entities/maintenance';
import { ApiService } from '@shared/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService extends ApiService<Maintenance> {
  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/maintenance';
    const detailUrl = '/maintenance/{id}';
    const detailProperty = 'maintenance';

    super(Maintenance, masterUrl, detailUrl, 'maintenance', detailProperty);
  }

  getBySerialNumber(serialNumber: string): Observable<Maintenance> {
    const { locationId } = this.activatedRoute.snapshot.queryParams;
    if (locationId) {
      this.setUrlParameter('locationId', locationId);
    }
    this.setUrlParameter('serialNumber', serialNumber);
    return this.findOne('');
  }
}
